import {
  Flex,
  IconButton,
} from '@chakra-ui/react';
import InsightProvider from '@/insight/lib/insightProvider';
import ExperienceProvider from '@/experiences/lib/experienceProvider';
import InsightCardListItem from './insightCardListItem';
import { useEffect, useRef, useState } from 'react';
import {  MdChevronLeft, MdChevronRight } from 'react-icons/md';
export default function SlidingInsights({ list, onSetAsOutdated, forceUpdate }) {
  const scrollRef = useRef();
  const isScrollingByButtonRef = useRef(false);
  const scrollEndFallbackRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [arrowOpacity, setArrowOpacity] = useState(0);
  const updateScrollButtons = () => {
    const el = scrollRef.current;
    if (!el || isScrollingByButtonRef.current) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };
  const syncScrollButtonsAfterAnimation = () => {
    const el = scrollRef.current;
    if (!el) return;
    if (scrollEndFallbackRef.current) {
      clearTimeout(scrollEndFallbackRef.current);
      scrollEndFallbackRef.current = null;
    }
    isScrollingByButtonRef.current = false;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };
  const scroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollAmount = el.clientWidth;
    const maxScrollLeft = el.scrollWidth - el.clientWidth;
    const nextScrollLeft = Math.max(0, Math.min(maxScrollLeft, el.scrollLeft + direction * scrollAmount));
    isScrollingByButtonRef.current = true;
    setCanScrollLeft(nextScrollLeft > 0);
    setCanScrollRight(nextScrollLeft + el.clientWidth < el.scrollWidth - 1);
    el.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    if (scrollEndFallbackRef.current) {
      clearTimeout(scrollEndFallbackRef.current);
    }
    scrollEndFallbackRef.current = setTimeout(syncScrollButtonsAfterAnimation, 400);
  };
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    updateScrollButtons();
    setTimeout(() => {
      updateScrollButtons();
    }, 100);
    el.addEventListener('scroll', updateScrollButtons);
    el.addEventListener('scrollend', syncScrollButtonsAfterAnimation);
    window.addEventListener('resize', updateScrollButtons);
    return () => {
      el.removeEventListener('scroll', updateScrollButtons);
      el.removeEventListener('scrollend', syncScrollButtonsAfterAnimation);
      window.removeEventListener('resize', updateScrollButtons);
      if (scrollEndFallbackRef.current) {
        clearTimeout(scrollEndFallbackRef.current);
      }
    };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      updateScrollButtons();
    }, 100);
  }, [forceUpdate]);
  return (
    <Flex
    position="relative"
    w="100%"
    onMouseEnter={() => {
      setArrowOpacity(1)
    }}
    onMouseLeave={() => {
      setArrowOpacity(0)
    }}
    >
      {canScrollLeft && (
        <IconButton
          aria-label="Scroll left"
          icon={<MdChevronLeft />}
          position="absolute"
          left={2}
          zIndex={1}
          onClick={() => scroll(-1)}
          top={"50%"}
          fontSize="16px"
          transform={"translateY(-60%)"}
          variant="coralFill"
          opacity={arrowOpacity}
        />
      )}
      <Flex
        ref={scrollRef}
        gap={2}
        overflowX="auto"
        w="100%"
        pb={3}
        borderColor="divider.grey"
        scrollBehavior="smooth"
        sx={{
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          '-ms-overflow-style': 'none',
          scrollbarWidth: 'none',
        }}
      >
        {list.map((n, i) => (
          <InsightProvider
            key={n.id}
            insightId={n.id}
            originalInsight={n}
            originalPersonaList={n.personas}
            originalProductList={n.products}
            originalRights={n.rights}
          >
            <ExperienceProvider
              experienceId={n.experience_id}
              originalExperience={n.experience}
              originalRights={n.rights}
            >
              <Flex pl={i === 0 ? 3 : 0}>
                <InsightCardListItem
                  onSetAsOutdated={onSetAsOutdated}
                />
              </Flex>
            </ExperienceProvider>
          </InsightProvider>
        ))}
      </Flex>
      {canScrollRight && (
        <IconButton
          aria-label="Scroll right"
          icon={<MdChevronRight />}
          position="absolute"
          right={2}
          zIndex={1}
          top={"50%"}
          fontSize="16px"
          transform={"translateY(-60%)"}
          variant="coralFill"
          onClick={() => scroll(1)}
          opacity={arrowOpacity}
        />
      )}
    </Flex>
  );
}
